import React from "react";
import { Card, Descriptions, Tag } from "antd";

interface OrderSummaryCardProps {
  record: {
    sn: number;
    soNo: string;
    poNo: string;
    meycoNo: string;
    jobName: string;
    orderDate: string;
    shippingDate: string;
    status: string;
    orderType?: "Quote" | "Order" | "Invoice";
    tracking: string;
  };
}

export const OrderSummaryCard: React.FC<OrderSummaryCardProps> = ({
  record,
}) => (
  <Card size="small" style={{ marginTop: 12 }}>
    <Descriptions column={1} size="small" colon>
      <Descriptions.Item label="SO#">{record.soNo}</Descriptions.Item>
      <Descriptions.Item label="Type">
        {record.orderType?.toUpperCase() || "—"}
      </Descriptions.Item>
      <Descriptions.Item label="PO#">{record.poNo || "—"}</Descriptions.Item>
      <Descriptions.Item label="Meyco#">
        {record.meycoNo || "—"}
      </Descriptions.Item>
      <Descriptions.Item label="Job Name">
        {record.jobName || "—"}
      </Descriptions.Item>
      <Descriptions.Item label="Order Date">
        {record.orderDate}
      </Descriptions.Item>
      <Descriptions.Item label="Est. Ship">
        {record.shippingDate || "—"}
      </Descriptions.Item>
      <Descriptions.Item label="Status">{record.status}</Descriptions.Item>
      <Descriptions.Item label="Tracking">
        {record.tracking || "—"}
      </Descriptions.Item>
    </Descriptions>
  </Card>
);
